import React from "react";
import Button from "../common/Button/Button";
import "./HeroSection.css";

const HeroSection = ({
  titleLine1,
  titleLine2,
  subtitle,
  ctaText,
  onCtaClick,
  backgroundImageUrl,
}) => {
  const heroStyle = {
    backgroundImage: `url(${backgroundImageUrl})`,
  };

  return (
    <section className="_hWrapper_k2B_" style={heroStyle}>
      <div className="_hGradOverlay_l3C_"></div>
      <div className="_hTextContent_m4D_">
        <h1 className="_hHeadline_n5E_">
          <span className="_hHeadlineLine1_o6F_">{titleLine1}</span>
          <span className="_hHeadlineLine2_p7G_">{titleLine2}</span>
        </h1>
        <p className="_hDesc_q8H_">{subtitle}</p>
        <div className="_hCtaWrapper_r9I_">
          <Button onClick={onCtaClick} className="_btnPrimary_s0J_">
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;